export const STYLEBOARD_COPY_YOUR_STYLEBOARD = 'styleboard.your.styleboard'
export const STYLEBOARD_COPY_TAP_THE_HEART = 'styleboard.tap.the.heart'
export const STYLEBOARD_COPY_OK_GOT_IT = 'styleboard.ok.got.it'
export const STYLEBOARD_COPY_ADD_ITEMS_WHILE_BROWSING = 'styleboard.add.items.while.browsing'
export const STYLEBOARD_COPY_NEW_FEATURE = 'styleboard.new.feature'
export const STYLEBOARD_COPY_WE_CALL_IT_STYLEBOARD = 'styleboard.we.call.it.styleboard'
export const STYLEBOARD_COPY_UPDATED_BOARD = 'styleboard.updated.board'
export const STYLEBOARD_COPY_ADD_ITEM_TO_BOARD = 'styleboard.add.item.to.board'
export const STYLEBOARD_COPY_CREATE_BOARD = 'styleboard.create.board'
export const STYLEBOARD_COPY_SAVE_BUTTON_TITLE = 'styleboard.save.button.title'
export const STYLEBOARD_COPY_CANCEL_BUTTON_TITLE = 'styleboard.cancel.button.title'
export const STYLEBOARD_COPY_BOARD_NAME = 'styleboard.board.name'
export const STYLEBOARD_COPY_BOARD_DESCRIPTION = 'styleboard.board.description'
export const STYLEBOARD_COPY_VISIBILITY_SETTING = 'styleboard.visibility.setting'
export const STYLEBOARD_COPY_VISIBILITY_TITLE_PRIVATE = 'styleboard.visibility.title.private'
export const STYLEBOARD_COPY_CREATE_BUTTON_TITLE = 'styleboard.create.button.title'
export const STYLEBOARD_COPY_BOARD_NAME_REMINDER = 'styleboard.board.name.reminder'
export const STYLEBOARD_COPY_ITEM_ADDED_TO_SINGLE = 'styleboard.item.added.to.single'
export const STYLEBOARD_COPY_ITEM_ADDED_VIEW = 'styleboard.item.added.view'
export const STYLEBOARD_COPY_MUTIPLE_ITEMS_ADDED_VIEW = 'styleboard.multiple.items.added.view'
export const STYLEBOARD_COPY_LETS_CREATE_BOARD = 'styleboard.lets.create.board'
export const STYLEBOARD_COPY_EXPLORE_STYLES = 'styleboard.explore.styles'
export const STYLEBOARD_COPY_REASON_TO_CREATE = 'styleboard.reason.to.create'
export const STYLEBOARD_COPY_CREATE_A_STYLEBOARD = 'styleboard.create.a.styleboard'
export const STYLEBOARD_COPY_BY = 'styleboard.by'
export const STYLEBOARD_COPY_EMPTY_BOARD_TEXT = 'styleboard.empty.board.text'
export const STYLEBOARD_COPY_ITEM_COUNT = 'styleboard.item.count'
export const STYLEBOARD_COPY_FOLLOWERS_COUNT = 'styleboard.followers.count'
export const STYLEBOARD_COPY_EDIT_STYLEBOARD = 'styleboard.edit.styleboard'
export const STYLEBOARD_COPY_STYLBOARD_LINK = 'styleboard.copy.styleboard.link'
export const STYLEBOARD_COPY_DELETE_STYLEBOARD = 'styleboard.delete.styleboard'
export const STYLEBOARD_COPY_EDIT_PROFILE = 'styleboard.edit.profile'
export const STYLEBOARD_COPY_VISIBILITY_TITLE_PUBLIC = 'styleboard.visibility.title.public'
export const STYLEBOARD_COPY_DELETE_BOARD_TITLE = 'styleboard.delete.board.title'
export const STYLEBOARD_COPY_DELETE_BOARD_TEXT = 'styleboard.delete.board.text'
export const STYLEBOARD_COPY_DELETE_BUTTON_TITLE = 'styleboard.delete.button.title'
export const STYLEBOARD_COPY_ADD = 'styleboard.add'
export const STYLEBOARD_COPY_PRODUCT = 'styleboard.product'
export const STYLEBOARD_COPY_PHOTO = 'styleboard.photo'
export const STYLEBOARD_COPY_ADD_ITEMS_BROWSING = 'styleboard.add.items.browsing'
export const STYLEBOARD_COPY_ADD_ITEMS_EXPLANATION = 'styleboard.add.items.explanation'
export const STYLEBOARD_COPY_LETS_EXPLORE_STYLES = 'styleboard.lets.explore.styles'
export const STYLEBOARD_COPY_CHANGE_PROFILE_PHOTO = 'styleboard.change.profile.photo'
export const STYLEBOARD_COPY_CHANGE_BOARD_BACKGROUND_IMAGE = 'styleboard.change.board.image.title'
export const STYLEBOARD_COPY_USER_NAME = 'styleboard.user.name'
export const STYLEBOARD_COPY_REMOVE_IMAGE = 'styleboard.remove.image'
export const STYLEBOARD_COPY_ADD_PHOTO = 'styleboard.add.photo'
export const STYLEBOARD_COPY_WRITE_CAPTION = 'styleboard.write.caption'
export const STYLEBOARD_COPY_DONE = 'styleboard.done'
export const STYLEBOARD_COPY_FOLLOW_BUTTON = 'styleboard.follow.button'
export const STYLEBOARD_COPY_FOLLOWING_BUTTON = 'styleboard.following.button'
export const STYLEBOARD_COPY_THANKS_FOLLOWING = 'styleboard.thanks.following'
export const STYLEBOARD_COPY_LINK_TO_FOLLOWING = 'styleboard.link.to.following'
export const STYLEBOARD_COPY_SIMILAR_PRODUCTS = 'styleboard.similar.products'
export const STYLEBOARD_COPY_SAVED = 'styleboard.saved'
export const STYLEBOARD_COPY_MY_STYLEBOARDS = 'styleboard.my.styleboards'
export const STYLEBOARD_COPY_EMPTY_FOLLOWING_SECTION = 'styleboard.empty.following.section'
export const STYLEBOARD_COPY_POPULAR_STYLEBOARDS = 'styleboard.popular.styleboards'
export const STYLEBOARD_COPY_CAPTION_TEXT = 'styleboard.caption.text'
export const STYLEBOARD_COPY_YOU_CAUGHT_US = 'styleboard.you.caught.us'
export const STYLEBOARD_COPY_YOU_CAUGHT_US_TEXT = 'styleboard.you.caught.us.text'
export const STYLEBOARD_COPY_GET_INSPIRED = 'styleboard.get.inspired'
export const STYLEBOARD_COPY_GO_TO_HOME = 'styleboard.go.to.home'
export const STYLEBOARD_COPY_TRY_IT_OUT = 'styleboard.try.it.out'
export const STYLEBOARD_COPY_LOG_IN_AND_CREATE = 'styleboard.log.in.and.create'
export const STYLEBOARD_COPY_LOG_IN_TO_EXPLORE = 'styleboard.log.in.to.explore'
export const STYLEBOARD_COPY_MAKES_IT_EASY = 'styleboard.makes.it.easy'
export const STYLEBOARD_COPY_LOG_IN = 'styleboard.log.in'
export const STYLEBOARD_COPY_YOU_NEED_TO_LOGGED_IN = 'styleboard.you.need.to.logged.in'
export const STYLEBOARD_COPY_PUBLIC_BOARD = 'styleboard.public.board'
export const STYLEBOARD_COPY_COPIED_THE_LINK = 'styleboard.copied.the.link'
export const STYLEBOARD_COPY_IMAGE_SIZE_LIMIT = 'styleboard.image.size.limit'
export const STYLEBOARD_COPY_ITEM_COUNT_SINGLE = 'styleboard.item.count.single'
export const STYLEBOARD_COPY_MORE_DESCRIPTION = 'styleboard.more.description'
export const STYLEBOARD_COPY_LESS_DESCRIPTION = 'styleboard.less.description'
export const STYLEBOARD_COPY_STYLEBOARD_DELETED = 'styleboard.styleboard.deleted'
export const STYLEBOARD_COPY_UNFOLLOW_BOARD_TITLE = 'styleboard.unfollow.board.title'
export const STYLEBOARD_COPY_UNFOLLOW_BOARD_TEXT = 'styleboard.unfollow.board.text'
export const STYLEBOARD_COPY_UNFOLLOW_BOARD_CONFIRMATION = 'styleboard.unfollow.board.confirmation'
export const STYLEBOARD_UPDATE_PROFILE_PICTURE_LINK = 'styleboard.update.profile.picture.link'
export const STYLEBOARD_GO_TO_ITEM = 'styleboard.go.to.item'
export const STYLEBOARD_ARTICLE_ITEM_OVERLAY_DELETE = 'styleboard.article.item.overlay.delete'
export const STYLEBOARD_IMAGE_ITEM_OVERLAY_DELETE = 'styleboard.image.item.overlay.delete'
export const STYLEBOARD_IMAGE_ITEM_OVERLAY_TITLE = 'styleboard.image.item.overlay.title'
export const STYLEBOARD_BOARD_SETTINGS = 'styleboard.board.settings'
export const STYLEBOARD_BOARD_TAB_MY_STYLEBOARD = 'styleboard.styleboard.tab.headline'
export const STYLEBOARD_BOARD_TAB_SIMILAR_ITEMS = 'styleboard.similar.items.tab.headline'
export const STYLEBOARD_BOARD_TAB_SIMILAR_ITEMS_EMPTY = 'styleboard.similar.item.empty.text'
export const STYLEBOARD_BOARD_UNIQUE_NAME_ERROR = 'styleboard.unique.name.error'
export const STYLEBOARD_BOARD_TITLE = 'styleboard.title'
export const STYLEBOARD_BOARD_FILTER_SORT_TITLE = 'styleboard.landingpage.filtersort.title'
export const STYLEBOARD_BOARD_SORT_UPDATED = 'styleboard.landingpage.sort.title.updated.date'
export const STYLEBOARD_BOARD_SORT_FOLLOWERS = 'styleboard.landingpage.sort.title.followers'
export const STYLEBOARD_BOARD_SORT_CREATION = 'styleboard.landingpage.sort.title.creation.date'
export const STYLEBOARD_VIEW_ALL_STYLEBOARDS = 'styleboard.landingpage.view.all.styleboards'
